import { post } from '@/utils/network';
import { BarrageItem } from '@/components/baberrage/messageType';
import { TypeMsgData } from '../speakHistory';

// 获取图片或者ppt、pdf地址
// courseid: 课程id; interactid: 课件id; type: 暂时无用，写死2
export function getCourseWareUrl(params: { courseid: string; interactid: string; type: '2' }) {
  return post<{
    data: any; // {1: {,…}, 2: {,…}, 3: {,…}, 4: {,…}, 5: {,…}, 6: {,…}, 7: {,…}, 8: {,…}, 9: {,…}, 10: {,…}}
    ext: string;
    pageCount: number;
    pptUrl: string;
    state: number;
  }>('/InteractWithScreenApi/listSlides', params);
}
// 获取直播地址  type:1  直播  2录播   移动端只有学生端，只需要获取直播地址
export function getLiveUrl(params: { classtimeid: string; classid: string; type: 1 }) {
  return post<{
    m3u8: string;
    rtmp: string;
    flv: string;
    artc: string;
    useartc:number;//是否使用artc
    viewType:number;
    livepushid:string;
    liveLists:Array<any>;
  }>('/Live/LiveApi/getLivePushUrl', params);
}
export interface InterfaceResBarrage {
  avatar: string;
  content: string;
  createtime: string;
  id: string;
  owner: boolean;
  uid: string;
  username: string;
  barrageClass?: string;
  color?: string;
}
// 获取弹幕列表
export function getBarrageList(params: { classtimeid: string; page: number; limit: number }) {
  return post<InterfaceResBarrage[]>('/Futurev2/Barrage/lists', params);
}

interface Common {
  recordStatus: boolean; // true,添加记录，false更新状态
  type: string; // 1抢答2话题3互动4提问5课件6资料
  id: string;
  objectid: string;
  typeName: string;
  createtime: string;
}
// 抢答  type = 1
export interface QiangDa extends Common {
  type: '1';
  // 课堂记录显示时间
  showtime: any;
  over: boolean; // 是否结束
  data: {
    id: string; // 抢答答id
    totalNum: string; // 总名额
    status: string; // 抢答状态 1进行 2结束
    type: string; // 抢答类型 1口头回答 2手机回答
    already: true; // 抢答名额没有了 true是 false否
    alreadyNum: string; // 抢答人数
    join: boolean; // 是否参加
  };
}
// 话题 type = 2
export interface HuaTi extends Common {
  type: '2';
  // 课堂记录显示时间
  showtime: any;
  data: {
    id: string; // 话题id
    title: string; // 话题标题
    discussNum: string; // 讨论人数
    join: boolean; // 是否参与
    reply: {
      replyId: string; // 回复id
      avatar: string; // 用户头像
      username: string; // 用户名
      content: string; // 回复内容
      attachment: {
        fileid: string; // 文件名
        ext: string; // 大图
        ext_s: string; // 小图（多数情况下用这个字段显示缩略图）
        ext_type: string; // 扩展名
        size: string; // 大小
        name: string; // 文件名
        url: string; // 链接（未知意义）
        date: string; // 日期
        rurl: string; // 预览链接
      };
    };
  };
}
// 互动type = 3
export interface HuDong extends Common {
  type: '3';
  // 课堂记录显示时间
  showtime: any;
  over: boolean; // 是否结束
  data: {
    id: string | string[]; // 互动id
    over: string; // 是否结束 0进行 1结束
    joinNum: string; // 总参与人数
    join: boolean; // 是否参加
    stepList: {
      id: string; // 互动试题id
      type: string; // 试题类型
      title: string; // 试题标题
      typeName: string; // 试题类型名称
      joinNum: string; // 试题参与人数
    };
  };
}
// 提问type = 4
export interface TiWen extends Common {
  type: '4';
  // 课堂记录显示时间
  showtime: any;
  data: {
    uid: string; // 用户id
    type: string; // 提问类型 0点名 1随机
    avatar: string; // 用户头像
    username: string; // 用户名
    typeName: string; // 提问类型名称
    join: boolean; // 是否被点名
  };
}
// 课件 type = 5
export interface KeJian extends Common {
  type: '5';
  // 课堂记录显示时间
  showtime: any;
  data: {
    title: string; // 课件标题
    src: string; // 大图地址
    thumb_src: string; // 缩略图地址
  };
}
// 资料 type = 6
export interface ZiLiao extends Common {
  type: '6';
  // 课堂记录显示时间
  showtime: any;
  data: {
    fileid: string; // 文件名
    ext: string; // 大图
    ext_s: string; // 小图（多数情况下用这个字段显示缩略图）
    ext_type: string; // 扩展名
    size: string; // 大小
    name: string; // 文件名
    url: string; // 链接（未知意义）
    date: string; // 日期
    rurl: string; // 预览链接
  };
}
//智慧黑板板书  type=9
export interface KeDaBlackBoardData extends Common {
  type: '9';
  // 课堂记录显示时间
  showtime: any;
  data: {
    name: string; // 图片标题
    src: string; // 大图地址
    thumb_src: string; // 缩略图地址
  };
}

//黑板板书  type=10
export interface BlackBoardData extends Common {
  type: '10';
  // 课堂记录显示时间
  showtime: any;
  data: {
    name: string; // 图片标题
    src: string; // 大图地址
    thumb_src: string; // 缩略图地址
  };
}

//截图  type=11
export interface ScreenShotData extends Common {
  type: '11';
  // 课堂记录显示时间
  showtime: any;
  data: {
    name: string; // 图片标题
    src: string; // 大图地址
    thumb_src: string; // 缩略图地址
  };
}

export type InterfaceLiveRecordItem = QiangDa | HuaTi | HuDong | TiWen | KeJian | ZiLiao | KeDaBlackBoardData | BlackBoardData | ScreenShotData;
// 获取课堂记录
export function getRecordList(params: { classtimeid: string; page: number; limit: number }) {
  return post<InterfaceLiveRecordItem[]>('/Futurev2/ClassRecord/lists', params);
}
export interface InterfaceBarrageConfig {
  status: string; // 1开启2关闭
  transparency: number; // 透明度
  color: string; // 颜色 1蓝色 2红色 3绿色 4黄5橙6紫7浅色8白9随机
  block: number; // 屏蔽区域1顶部 2中部 3底部
  anonymous: string; //  是否匿名 1是 2不是
}
// 获取弹幕配置
export function getBarrageConfig(arg: { courseid: string }) {
  return post<InterfaceBarrageConfig>('/FutureV2/Barrage/getConfig', arg);
}
// 发送弹幕
export function postBarrage(arg: {
  classtimeid: string; // 课堂小结
  content: string;
  free: boolean; // 是否使用弹幕vip动效体验
}) {
  return post<{
    avatar: string;
    content: string;
    createtime: string;
    uid: number;
    username: string;
  }>('/Futurev2/Barrage/sendBarrage', arg);
}

// 发送弹幕
export function getVipBarrageCount() {
  return post<{
    useCount: string; // 已使用条数
    maxCount: string; // 总条数
  }>('/Futurev2/Barrage/getVIPBarrageUseCount');
}

// 发言
export function postSpeak(arg: {
  classtimeid: string; // 课堂小结id
  uid: string;
  content: string; // 发送的内容
  attachment_annex: string; // 附件id
  attachment_picture: string; // 图片id
}) {
  return post<TypeMsgData[]>('/Futurev2/Speak/sendLetter', arg);
}
// 获取是否允许发言
export function getAllowSpeak(arg: {
  classtimeid: string; // 课堂小结id
  uid: string;
}) {
  return post<boolean>('/Futurev2/Speak/getUserConfig', arg);
}

// 参与抢答
export function postJoinRace(arg: { courseid: string; classtimeid: string | null; raceid: string; content: string }) {
  return post('/Futurev2/Tools/joinRace', arg);
}

// 参与抢答
export function getSpeakHistory(arg: { classtimeid: string; uid: string; page: number; limit: number }) {
  return post('/Futurev2/Speak/getHistory', arg);
}
// 互动课件 学生疑问-状态切换   state 0 没有疑问，1有疑问
export function setProblemState(params: { interactid: string; pageindex: string; state: string }) {
  return post('/PrestudyTaskApi/setDoubtState', params);
}

// 互动课件 学生疑问-状态切换   state 0 没有疑问，1有疑问
export function getWxConfig() {
  return post<{
    appId: string;
    timestamp: string;
    nonceStr: string;
    signature: string;
  }>('/WechatApi/getSignPackage');
}
// 获取当前抢答信息
export function getCurrentRace(form: { courseid: string }) {
  return post<QiangDa>('/Futurev2/Tools/getStudentCurrentRace', form);
}

// 获取当前互动，可能多个
export function getCurrentHudong(form: { courseid: string; classtimeid: string }) {
  return post<{ stepid: { id: string }[] }>('/InteractApi/isExistJoinStepV2', form);
}
// 学生观看直播（心跳访问）
export const watchLiveLog = (params: { livepushid: string; courseid:string}) => {
  return post('/Live/LiveApi/watchLiveLog', params)
}
